import { Nav } from "./routes";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en, fr } from "./i18n";
import { getSystemLanguage } from "./utils";
import { makeStyles } from "@mui/styles";
import { ThemeProvider } from "./provider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GlobalProvider } from "./context/globalContext";

const useStyles = makeStyles(theme => ({
  fullScreen: {
    width: "100%",
    //minheight: "100vh",
    overflow: "hidden",
    backgroundImage: "url(./assets/background_large.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
}));

// One client for the life of the session. Built inside the render body it was
// discarded on every re-render of the root, so every cached read became a
// fresh network round trip and no value could be resolved once per session.
const queryClient = new QueryClient({ defaultOptions: {} });

// i18n is initialised once, at module load. Run from the render body it
// emitted a language-change while React was rendering, which updated a
// descendant mid-render and looped until React gave up.
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: { en, fr },
      lng: getSystemLanguage(),
      fallbackLng: "en",
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });
}

const App = () => {
  const classes = useStyles();

  return (
    <div className={classes.fullScreen}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          {/* PortalProvider used to sit here. It resolves the tenant with a
              query gated on the auth token, and it read that token during its
              own render -- above AuthProvider, which is what writes it. On a
              first visit the storage is empty, so the query never ran and the
              payer sat on a spinner. It now lives inside AuthProvider in
              nav.tsx, still below this provider, which it feeds. */}
          <GlobalProvider>
            <Nav />
          </GlobalProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </div>
  );
};

export default App;
